import { z } from "zod";
import { accessEvents } from "./access";
import { billingEvents } from "./billing";
import { certificateEvents } from "./certificate";
import { dataSubjectEvents } from "./data-subject";
import { emailEvents } from "./email";
import { formEvents } from "./form";
import { notificationEvents } from "./notification";
import { operationsEvents } from "./operations";
import { recordingEvents } from "./recording";
import { signInEvents } from "./sign-in";
import { siteEvents } from "./site";
import { siteManagerEvents } from "./site-manager";
import { workerApprovalEvents } from "./worker-approval";

export * from "./access";
export * from "./billing";
export * from "./certificate";
export * from "./data-subject";
export * from "./email";
export * from "./envelope";
export * from "./form";
export * from "./notification";
export * from "./operations";
export * from "./recording";
export * from "./sign-in";
export * from "./site";
export * from "./site-manager";
export * from "./worker-approval";

// Discriminated union over `type` covering every domain event the log accepts.
export const domainEvent = z.discriminatedUnion("type", [
  ...signInEvents,
  ...recordingEvents,
  ...certificateEvents,
  ...formEvents,
  ...workerApprovalEvents,
  ...siteManagerEvents,
  ...notificationEvents,
  ...emailEvents,
  ...billingEvents,
  ...dataSubjectEvents,
  ...siteEvents,
  ...accessEvents,
  ...operationsEvents,
]);

export type DomainEvent = z.infer<typeof domainEvent>;
export type DomainEventType = DomainEvent["type"];
